import Logger from '../Components/ConsoleLogger';
import { isProduction } from '../Components/Utils/environment';

const Log = new Logger('FW-UI-COMPONENTS');
Log.init(!isProduction() ? Logger.LogLevel.all : Logger.LogLevel.none);

export default Log;
